export const constantsRegex = {
    EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    PHONE_NUMBER: /^[+]{1}(?:[0-9\-\(\)\/\.]\s?){6, 15}[0-9]{1}$/,
    PHONE_NUMBER_MASK: /^\+38 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
}